<template>
  <modal
    ref="modal"
    :modalId="`contractor-data-${+new Date()}`"
  >
    <div
      v-if="allVendorsIntegrated"
      slot="modal-header"
    >
      <label
        for="tender.general.contractData"
        class="header"
      >
        {{ $t('hint.whatWeFound') }}
      </label>
    </div>
    <p
      v-else
      slot="modal-header"
      class="modal-header"
    >
      {{ $t('hint.missingVendorData') }}:
    </p>

    <div
      slot="content"
      class="dialog-bg"
    >
      <template v-if="allVendorsIntegrated">
        <div class="pr-info-label">
          <label for="tender.general.budget">{{ $t('tender.general.prNumber') }}:</label>
        </div>
        <div>
          <span
            id="tender.general.budget"
            class="pr-info"
          >
            {{ contractData.number }}
          </span>
        </div>

        <div v-show="contractData.description">
          <span
            id="tender.general.budget"
            class="pr-info"
          >
            {{ contractData.description }}
          </span>
        </div>

        <div class="pr-info-label">
          <label for="tender.general.budget">{{ $t('tender.general.estimatedBudget') }}:</label>
        </div>
        <div>
          <span
            id="tender.general.budget"
            class="pr-info"
          >
            {{ contractData.budget | formatCurrency({currencyCode: contractData.currencyCode}) }}
          </span>
        </div>

        <div class="pr-info-label">
          <label for="tender.general.site">{{ $t('tender.general.siteId') }}:</label>
        </div>
        <div>
          <span
            id="tender.general.site"
            class="pr-info"
          >
            {{ contractData.siteId || '--' }}
          </span>
        </div>

        <div class="pr-info-label">
          <label for="tender.general.vendors">{{ $t('tender.general.vendors') }} ({{ totalVendorCount }}):</label>
        </div>
        <ul>
          <li
            v-for="vendorAccount in contractData.vendors"
            :key="vendorAccount.id"
          >
            {{ deep(vendorAccount, 'name') || '' }}
          </li>
        </ul>
      </template>
      <template v-else>
        <div
          id="tender.general.budget"
          class="error-hint-msg"
        >
          {{ $t('hint.missingVendorOperation') }}
        </div>
        <br>
        <div
          v-for="vendorId in Object.keys(contractData.vendors || {})"
          v-if="!deep(contractData, `vendors.${vendorId}`)"
          :key="vendorId"
        >
          <div
            id="tender.general.budget"
            class="error-hint-msg"
          >
            {{ vendorId }}
          </div>
        </div>
      </template>
    </div>
    <div slot="btns">
      <div
        v-if="allVendorsIntegrated"
        slot="btns"
        class="dialog-btn row align-right nav_btn"
      >
        <button
          id="tender.general.contractData.cancel"
          class="btn btn--darkblue button-margin"
          @click="cleanContractData"
        >{{ $t('action.goback') }}</button>
        <button
          id="tender.general.contractData.save"
          class="btn btn--orange button-margin"
          @click="setContractData"
        >{{ $t('action.yesThatsit') }}</button>
      </div>

      <div
        v-else
        class="row align-center nav_btn"
      >
        <button
          id="tender.general.contractData.cancel"
          class="btn btn--darkblue button-margin"
          @click="cleanContractData"
        >{{ $t('hint.okay') }}</button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex'

import EventBus from '@/utils/eventBus'
import Modal from '@/controls/Modal'

export default {
  name: 'ContractData',
  components: {
    Modal,
  },
  props: {
    contractData: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      deep,
    }
  },
  computed: {
    totalVendorCount () {
      return this.contractData && this.contractData.vendors ? Object.keys(this.contractData.vendors).length : '-'
    },
    allVendorsIntegrated () {
      return Object.values(deep(this.contractData, 'vendors') || { 1: null }).every(rec => rec)
    },
  },
  methods: {
    ...mapActions('tenders', [
      'saveCurrentTender',
    ]),
    openModal () {
      this.$refs.modal.open()
    },
    closeModal () {
      this.$refs.modal.close()
    },
    cleanContractData () {
      this.$refs.modal.close()
      EventBus.$emit('cleanContractData')
    },
    async setContractData () {
      this.$refs.modal.close()
      EventBus.$emit('setContractData')
      await this.saveCurrentTender()
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  line-height: 1;
  margin-bottom: 20px;
  font-family: Georgia;
  font-size: x-large;
  font-style: italic;
  text-align: left;
  color: #0c3a58!important;
}

.pr-info-label label {
  width: 100%;
  font-family: Verdana;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: #0C3A58!important;
  text-transform: uppercase;
}

ul {
  list-style-type: decimal;
  margin-bottom: 0;
}

</style>
